import Components from 'HHC/Components';

const TILDE_KEY = 192;

/**
 * Debug-утилита `grid` отображает колоночную сетку на странице по фиче grid
 * либо по шорткату [ctrl] + [~] ([ctrl] + [shift] + [~] при открытом инспекторе)
 *
 * @exports HHC/Debug/Grid
 */
const Grid = () => {
    const grid = document.querySelector('.HHC-Debug-Grid');
    const show = () => grid.classList.remove('g-hidden');
    const hide = () => grid.classList.add('g-hidden');

    if (grid) {
        document.addEventListener('keyup', (event) => {
            if (event.ctrlKey && event.keyCode === TILDE_KEY) {
                if (grid.classList.contains('g-hidden')) {
                    show();
                } else {
                    hide();
                }
            }
        });
    }

    return { show, hide };
};

export default Components.build({ create: Grid });
